// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"161":"ef71e7ec","591":"0b386fe6"}[chunkId] + ".chunk.css";
};